import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchLocationDropdown } from './location-lists';
import { InputOverlay } from '../input-overlay';
import { InputAddOn } from '../input-group-addon';

export class LocationDropdown extends Component {
  render () {
    const {
      locations,
      whichDropdown,
      metros,
      locationPlaceholder,
      location,
      dataLocation,
      onBlurLocation,
      onFocusLocation,
      onChange,
      onKeyDown,
      clickMetro,
      clickPoi,
      inputRef,
      inputOverlayRef,
      toggleModal,
      inputClassName,
      inputAttributes
    } = this.props;

    return (
      <div>
        <InputAddOn
          leftAddon={this.props.addOnImage}
        >
          <InputOverlay
            id="search-location-input"
            ref={inputOverlayRef}
            inputRef={inputRef}
            inputShownValue={location}
            inputDataValue={dataLocation}
            placeholder={locationPlaceholder}
            onBlurFn={onBlurLocation}
            onFocusFn={onFocusLocation}
            onChange={onChange}
            onKeyDown={onKeyDown}
            idToIgnoreToggle="search-location-input"
            inputClassName={inputClassName}
            containerClassName="text-base"
            {...inputAttributes}
          >
            <SearchLocationDropdown
              selectedLocation={location}
              metros={metros}
              locations={locations}
              whichDropdown={whichDropdown}
              clickMetro={clickMetro}
              clickPoi={clickPoi}
              toggleModal={toggleModal}
            />
          </InputOverlay>
        </InputAddOn>
      </div>
    );
  }
}

LocationDropdown.propTypes = {
  metros: PropTypes.array,
  locations: PropTypes.array,
  whichDropdown: PropTypes.string,
  locationPlaceholder: PropTypes.string,
  location: PropTypes.string,
  onBlurLocation: PropTypes.func,
  onFocusLocation: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  clickMetro: PropTypes.func,
  clickPoi: PropTypes.func,
  inputRef: PropTypes.func,
  dataLocation: PropTypes.object,
  toggleModal: PropTypes.func,
  inputClassName: PropTypes.string
};
